import {messagesService} from "@dv5/api"
import {Widget} from "@dv5/domain"

export interface WidgetDataChange {
    widgetId: string
    patchedPaths: Array<string>
    data: Widget["data"]
}

class CanvasWidgetsDataService {
    changeWidgetsData(canvasId: string, changes: Array<WidgetDataChange>) {
        messagesService.send('canvas.change-widgets-data', {
            canvasId,
            changes,
        })
    }
}

export const canvasWidgetsDataService = new CanvasWidgetsDataService()
